import { STATUS_OPTIONS_MAP } from "./constants";
import { useModerationSettingsInfiniteQuery } from "./ModerationTable/useModerationSettingsInfiniteQuery";

export const useReportsAmounts = () => {
  const { totalRecords: inboxCount, isLoading: isInboxLoading } =
    useModerationSettingsInfiniteQuery({
      status: STATUS_OPTIONS_MAP.INBOX,
    });

  const { totalRecords: approvedCount, isLoading: isApprovedLoading } =
    useModerationSettingsInfiniteQuery({
      status: STATUS_OPTIONS_MAP.APPROVED,
    });

  const { totalRecords: rejectedCount, isLoading: isRejectedLoading } =
    useModerationSettingsInfiniteQuery({
      status: STATUS_OPTIONS_MAP.REJECTED,
    });

  const totalReports = inboxCount + approvedCount + rejectedCount;
  const isLoading = isInboxLoading || isApprovedLoading || isRejectedLoading;

  return {
    inboxCount,
    approvedCount,
    rejectedCount,
    totalReports,
    isLoading,
  };
};
